var _path, _linearGradient, _g, _linearGradient2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSpingoFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232 98"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.3 63h21.9l-1 6.1h-9.4l-.8 4.6h8.8l-.9 6.1h-9.1l-2 10.5h-6l3.3-19.8h3l-7.8-7.5zm37.4 27.2l1-6h-9.9l3.6-21.1h-5.8L144 90.3c0-.1 15.7-.1 15.7-.1zM226.3 63l-1.8 10.6h-7.4l1.8-10.6h-5.7l-4.6 27.2h5.7l1.8-11.1h7.4l-1.8 11.1h5.7L232 63h-5.7 0zm-46.4 21.6h-7.7l-2.3 5.6h-6.6l12-27.2h7.6l3.6 27.2h-6.1l-.5-5.6zm-.5-5.4l-.9-10.5-4.2 10.5h5.1z",
    fill: "#010202",
    stroke: "#010202",
    strokeWidth: 0.568,
    strokeMiterlimit: 10
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 176.937,
    y1: 89.959,
    x2: 176.937,
    y2: 62.745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#71c6d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#71c6d1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#010202",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.1 62.7H144l-1 6.1h-9.4l-.8 4.6h8.8l-.9 6.1h-9.1l-2 10.5h-6l3.3-19.8h3l-7.8-7.5zM159.5 90l1-6h-9.9l3.6-21.1h-5.8L143.7 90h15.8zm66.6-27.3l-1.8 10.6h-7.4l1.8-10.6H213l-4.6 27.2h5.7l1.8-11.1h7.4l-1.8 11.1h5.7l4.6-27.2h-5.7zm-46.4 21.7H172l-2.3 5.6h-6.6L175 62.8h7.6l3.6 27.2h-6.1l-.4-5.6zm-.5-5.4l-.9-10.5L174 79h5.2z",
    fill: "url(#A)",
    strokeWidth: 0.161
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.2 57.1l-26.3 7.4-11.5 11.8 10.6 4.2-18.4 17 29.6-18.7-9.4-4.7 25.4-17z",
    fill: "#010202",
    strokeWidth: 0.568
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 199.579,
    y1: 96.93,
    x2: 199.579,
    y2: 56.492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#71c6d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#71c6d1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222.4 56.5l-26.3 7.4-11.5 11.8 10.6 4.2-18.4 17 29.7-18.8-9.4-4.7 25.3-16.9z",
    fill: "url(#B)",
    stroke: "#010202",
    strokeWidth: 0.161,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.4 39.3a10.38 10.38 0 01-2.3 3.6l2.8 3.2h-2.6l-1.6-1.9c-1.7 1.5-3.1 2.1-4.4 2.1-1.9 0-3.5-1.4-3.5-3.2 0-1.6 1.3-2.9 3.3-4-.8-.8-1.6-2-1.6-3.2 0-1.9 1.4-3.2 3.5-3.2 1.9 0 3.3 1.3 3.3 3 0 1.3-.7 2.4-2.5 3.6l1.9 2.2c.6-.6 1.2-1.5 1.5-2.2h2.2zm-7 1c-1.5 1-2.4 1.7-2.4 2.7.1.8.8 1.4 1.7 1.4 1 0 2-.7 3-1.6l-2.3-2.5zm.5-2.3c1.5-.9 1.8-1.5 1.8-2.2 0-.8-.7-1.4-1.6-1.4s-1.5.6-1.5 1.3c0 .8.7 1.7 1.3 2.3zm-83.2 6.8c0 2.4-.8 4.4-2.5 6.1s-3.7 2.5-6.1 2.5H0L5.1 47h11c.6 0 1.1-.2 1.6-.6.4-.4.6-.9.6-1.6 0-.6-.2-1.1-.6-1.6-.4-.4-1-.6-1.6-.6H8.7c-2.4 0-4.4-.8-6.1-2.5-1.8-1.7-2.6-3.7-2.6-6s.8-4.4 2.5-6.1 3.7-2.5 6.1-2.5h16l-5.1 6.4h-11c-.6 0-1.1.2-1.6.6-.4.4-.6.9-.6 1.6 0 .6.2 1.1.6 1.6.6.3 1.1.5 1.8.5H16c2.4 0 4.4.8 6.1 2.5 1.8 1.7 2.6 3.8 2.6 6.1zm27.2-10.7c0 2.4-.8 4.4-2.5 6.1s-3.7 2.5-6.1 2.5h-8.5l5.1-6.4h3.4c.6 0 1.1-.2 1.6-.6.4-.4.6-.9.6-1.6 0-.6-.2-1.1-.6-1.6-.4-.4-.9-.6-1.6-.6h-9.6v21.5h-6.5V25.5h16c2.4 0 4.4.8 6.1 2.5 1.8 1.7 2.6 3.7 2.6 6.1zm8.9 19.3h-6.5V25.5h6.5v27.9zm27.8 0h-6.5L70.3 37.6v15.8h-6.5V25.5h6.5l11.8 15.8V25.5h6.5v27.9zm97.9-14c0 3.9-1.4 7.1-4.1 9.9-2.8 2.7-6.1 4.1-10 4.1s-7.2-1.4-10-4.1-4.1-6-4.1-9.9 1.4-7.1 4.1-9.9c2.8-2.7 6.1-4.1 10-4.1s7.2 1.4 10 4.1c2.7 2.8 4.1 6.1 4.1 9.9zm-6.5 0c0-2.1-.7-3.9-2.2-5.4s-3.3-2.2-5.4-2.2-3.9.7-5.4 2.2-2.3 3.3-2.3 5.4.7 3.9 2.3 5.4c1.5 1.5 3.3 2.2 5.4 2.2s3.9-.7 5.4-2.2 2.2-3.3 2.2-5.4zm-23.7 14h-12.6c-3.9 0-7.2-1.4-10-4.1s-4.1-6-4.1-9.9 1.4-7.1 4.1-9.9c2.8-2.7 6.1-4.1 10-4.1h12.6l-5 6.4h-7.6c-2.1 0-3.9.7-5.4 2.2s-2.2 3.3-2.2 5.4.7 3.9 2.2 5.4 3.3 2.2 5.4 2.2h6.1v-4.4H143l5-6.4h8.2v17.2z",
    fill: "#fff"
  })));
}
SvgLogoSpingoFlash.displayName = 'LogoSpingoFlash';
export default SvgLogoSpingoFlash;